import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ruTrans from "./ru.json";
import enTrans from "./en.json";

!localStorage.getItem("language") && localStorage.setItem("language", "ru");
let language = localStorage.getItem("language");

i18n.use(initReactI18next).init({
  lng: language,
  fallbackLng: "ru",
  debug: true,

  resources: {
    en: {
      translation: enTrans,
    },
    ru: {
      translation: ruTrans,
    },
  },

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
